import { ResponsiveThemeData } from '../themes/Theme';

export type Spacing = string;

enum Spacings {
  xxxxxxLarge = '8rem', // '128px'
  xxxxxLarge = '6rem', // '96px'
  xxxxLarge = '5rem', // '80px'
  xxxLarge = '4rem', // '64px'
  xxLarge = '3rem', // '48px'
  xLarge = '2rem', // '32px'
  large = '1.5rem', // '24px'
  medium = '1rem', // '16px'
  small = '0.75rem', // '12px'
  xSmall = '0.5rem', // '8px'
  xxSmall = '0.25rem', // '4px'

  none = '0rem'
}

export default Spacings;

export type DimensionalSpacing = string;

export type ResponsiveSpacing = ResponsiveThemeData<Spacing>;

export const createCustomSpacing = (multiplier: number): string => `${multiplier}rem`;
